export const isNostrExtensionInstalled = (): boolean => {
  return typeof window !== 'undefined' && 'nostr' in window;
};

export const getNostrPublicKey = async (): Promise<string | null> => {
  if (!isNostrExtensionInstalled()) {
    return null;
  }

  try {
    const nostr = (window as any).nostr;
    const publicKey = await nostr.getPublicKey();
    return publicKey;
  } catch (error) {
    console.error('Error getting Nostr public key:', error);
    return null;
  }
};

export const signMessage = async (message: string): Promise<object | null> => {
  if (!isNostrExtensionInstalled()) {
    return null;
  }

  try {
    const nostr = (window as any).nostr;
    const signature = await nostr.signEvent({
      kind: 1,
      created_at: Math.floor(Date.now() / 1000),
      tags: [],
      content: message,
    });
    return signature;
  } catch (error) {
    console.error('Error signing message:', error);
    return null;
  }
}; 